module.exports = "<lfwms-result-data-table [searchService]=\"searchService\" [tableMode]=\"dataService.displayMode\" (buttonActionHandler)=\"buttonService.handleMainButtonPanelActionsForTable($event, widgetConfig.id)\"></lfwms-result-data-table>\n    "


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/widget/commodity-advance-sku-widget/commodity-advance-sku-widget.html
// module id = ../../../../../src/app/shared/components/widget/commodity-advance-sku-widget/commodity-advance-sku-widget.html
// module chunks = main